import React from 'react';
import { Box, Tooltip, Text } from '@fullstory/components';
import css from '../index.module.scss';
import classNames from 'classnames';

type LabelProps = {
  label: string;
  noWrap: boolean;
};

export const Label = ({ label, noWrap }: LabelProps) => (
  <Text
    data-component="Label"
    appearance="bodyMediumBold"
    color="default"
    className={classNames(css.nodeLabel, { [css.singleLine]: noWrap })}
  >
    {label}
  </Text>
);

type SubLabelProps = {
  parts: [string, string];
};

export const SubLabel = ({ parts }: SubLabelProps) => (
  <Box data-component="SubLabel">
    <Tooltip
      placement="top"
      tooltipContent={
        <Text appearance="bodySmall" color="default-inverse">
          {parts[0]}:&nbsp;
          <Text appearance="bodySmallBold" color="default-inverse" tag="span">
            {parts[1]}
          </Text>
        </Text>
      }
      variant="dark"
      persistDelay={100}
    >
      <Text tag="div" noWrap appearance="bodySmall" color="emphasized">
        {parts[0]}&nbsp;
        <Text appearance="bodySmallBold" color="emphasized" tag="span">
          {parts[1]}
        </Text>
      </Text>
    </Tooltip>
  </Box>
);
